/* Moss & Molt phone-drawer Account line (moved out of snippets/mm-header-custom.liquid, audit #13, Oct 29 2026, so browsers cache it). Loaded with defer only when customer accounts are on; the URL comes from data-account-url. The early announcement-bar script stays inline (it must run before paint). */
(function () {
  var ACCOUNT_URL = (document.currentScript && document.currentScript.getAttribute('data-account-url')) || '/account';
  function addAccount() {
    var list = document.querySelector('#header-component .menu-drawer__menu.has-submenu');
    if (!list) return;
    var old = list.querySelector('.mm-drawer-account');
    if (old && !old.querySelector('.mm-drawer-account__icon')) return;   // already there, word only
    if (old) old.closest('li').remove();                                  // drop an earlier icon version
    var first = list.querySelector(':scope > li');
    var li = document.createElement('li');
    li.className = first ? first.className : 'menu-drawer__list-item--flat';
    var a = document.createElement('a');
    a.href = ACCOUNT_URL;
    a.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element mm-drawer-account';
    a.style.setProperty('--menu-drawer-animation-index', list.children.length);
    a.innerHTML = '<span class="menu-drawer__menu-item-text wrap-text">Account</span>';
    li.appendChild(a);
    list.appendChild(li);
  }
  function init() {
    addAccount();
    // the theme can redraw the header after load; put the Account line back if that happens
    var head = document.getElementById('header-component');
    if (head && 'MutationObserver' in window) new MutationObserver(addAccount).observe(head, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
